enum MsalAuthProcessStage {
  MsalInitialized = 'MsalInitialized',
  AuthRedirectionsComplete = 'AuthRedirectionsComplete',
  Ready = 'Ready',
}

export default MsalAuthProcessStage;
